import { useContext } from 'react';
import { Formik } from 'formik';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { CustomerForm } from './components';
import { customerSchema, customerContext } from './CustomerContext';

let Customers = () => {
    let service = useContext(customerContext);

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={service.customer}
                validationSchema={customerSchema}
                onSubmit={(values, action) => {
                    service.saveCustomer(values);
                    action.setSubmitting(false);;
                }}
            >
                {formProps =>
                    <>
                        {service.isLoading && <CircleLoader />}
                        {service.isLoading === false && <CustomerForm formProps={formProps} />}
                    </>
                }
            </Formik>
        </Container>
    )
}

export default Customers;